<template>
  <div>
    <div class="news-all">
      <div class="title">
        <span class="time">
          {{
            String(new Date(newsDetail.publishTime).getMonth() + 1).padStart(
              2,
              "0"
            )
          }}.{{
            String(new Date(newsDetail.publishTime).getDate()).padStart(2, "0")
          }}
          <br />{{ new Date(newsDetail.publishTime).getFullYear() }}
        </span>
        <span class="tiel">{{ newsDetail.title }}</span>
      </div>
      <div class="mat-content" v-html="newsDetail.content"></div>
    </div>
    <HomeFooter />
  </div>
</template>
<script>
import HomeFooter from "../home/components/footer";
export default {
  components: {
    HomeFooter,
  },
  data() {
    return {
      newsDetail: {},
    };
  }, // end data
  methods: {
    async getNewsDetail() {
      const newsDetail = await _api.all.getNewsDetail({
        id: this.$route.params.id,
      });
      // console.log("newsDetail", newsDetail);
      if (newsDetail && newsDetail.code == 200) {
        this.newsDetail = newsDetail.data[0];
      }
    },
  },
  created() {
    this.getNewsDetail();
  }, // end created
};
</script>

<style lang="scss" scoped>
.news-all {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 50px;
  .title {
    height: 68px;
    margin-top: 40px;
    .time {
      width: 88px;
      height: 68px;
      background: #bedccb;
      float: left;
      color: #fff;
      text-align: center;
      font-size: 24px;
      line-height: 1.2;
      padding-top: 8px;
    }
    .tiel {
      width: 895px;
      float: right;
      font-size: 24px;
      padding-top: 34px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .mat-content {
    margin-top: 35px;
    font-size: 16px;
    line-height: 1.5;
    .tet-js {
      margin-top: 24px;
      line-height: 2;
      color: #4a4a4a;
    }
  }
}
</style>
